<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="true"
    menu-classes="ml-auto"
    class="custom-navbar"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        <img class="navbar-logo" src="/Wegweiser.svg">
        mathias moeller
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow me on Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/mathiasmoelle_r"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow me on Facebook"
          data-placement="bottom"
          href="https://www.facebook.com/matze.moller.9"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Get in touch"
          data-placement="bottom"
          href="mailto:mail@mathiasmoeller.com"
          target="_blank"
        >
          <i class="fas fa-envelope"></i>
          <p class="d-lg-none d-xl-none">Contact</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
  import { Navbar } from '@/components';

  export default {
    name: 'landing-navbar',
    components: {
      Navbar,
    },
  };
</script>

<style lang="scss" scoped>
</style>
